"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabItemSize = void 0;
var TabItemSize;
(function (TabItemSize) {
    TabItemSize["FIT_CONTENT"] = "fit-content";
    TabItemSize["WITH_MIN_WIDTH"] = "with-min-width";
})(TabItemSize || (exports.TabItemSize = TabItemSize = {}));
